import { GOOGLE_STORAGE_URL } from '@config';

export const getSteamIconUrl = (url = '') =>
  `https://steamcommunity-a.akamaihd.net/economy/image/${url}`;

export const getCaseImageUrl = (url = '', isRifle = false) => {
  if (!url) return '';
  return `${GOOGLE_STORAGE_URL}${url}`;
};
